// extracted by mini-css-extract-plugin
export var backtoschool = "twoChoice-module--backtoschool--0LP8p";
export var btn = "twoChoice-module--btn--RJNi+";
export var btnBlue = "twoChoice-module--btnBlue--b7hVY";
export var btnMain = "twoChoice-module--btnMain--HhmEG";
export var btnNY = "twoChoice-module--btnNY--xjckv";
export var btnPurple = "twoChoice-module--btnPurple--tjUKy";
export var cashback100 = "twoChoice-module--cashback100--F2ufT";
export var cashback_factory = "twoChoice-module--cashback_factory--kMJLN";
export var content = "twoChoice-module--content--cWDjC";
export var firstCard = "twoChoice-module--firstCard--ldcHL";
export var genderAction = "twoChoice-module--genderAction--2J88P";
export var gridContainer = "twoChoice-module--gridContainer--iI6-h";
export var img = "twoChoice-module--img--mVeZa";
export var kiberponedelnik = "twoChoice-module--kiberponedelnik--1IdAJ";
export var nedeliUmnyhRassrochek = "twoChoice-module--nedeliUmnyhRassrochek--9Zbme";
export var newYearMediaRuby = "twoChoice-module--newYearMediaRuby--wmwGg";
export var samoletik = "twoChoice-module--samoletik--cbk3X";
export var schoolAction = "twoChoice-module--schoolAction--LxyP1";
export var secondCard = "twoChoice-module--secondCard--P151Z";
export var section = "twoChoice-module--section--2oh9+";
export var shapka = "twoChoice-module--shapka--DZDBr";
export var swapCard = "twoChoice-module--swapCard--4CNeZ";
export var textBlock = "twoChoice-module--textBlock--T+C9a";